// i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importez les fichiers de traduction ici
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationAR from './locales/ar/translation.json'; // Exemple pour la langue arabe

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr', // Langue par défaut
    fallbackLng: 'fr', // Langue de secours en cas de non-correspondance
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
